<template>
  <div>
    <error-500 />
  </div>
</template>
<script>
import Error500 from "@/components/system/Errors/500";
export default {
  components: {
    Error500,
  },
};
</script>
